import { render, staticRenderFns } from "./index.vue?vue&type=template&id=49aa52ab&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=49aa52ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49aa52ab",
  null
  
)

export default component.exports